import {
  HotelBadgeType,
  HotelInfo
} from "@website/accommodation-ui/hotel-card-new";
import { CityDataType } from "@website/accommodation-ui/hotel-search";
import { SeoDataResource } from "@website/accommodation-ui/hotel-seo-content";
import { MarketingBannerItemDataType } from "@website/widget/banner-slide";

export type HotelCategoriesType = Array<{
  label: string;
  name: string;
}>;

export type HotelDomesticType = {
  instant_book: boolean;
  accommodation_title: string;
  accommodation_type: string;
  address: string;
  categories: HotelCategoriesType;
  city_id: number;
  city_title: string;
  cover_media: { id: number; media: string; title: string };
  discount_percent: number;
  id: number;
  is_available: true;
  lang: "fa" | "ar" | "en";
  price: number;
  price_off: number;
  min_price_room_title: string;
  min_price_available_room_count: number;
  rule_id: number;
  reviews: {
    ptp_ratings: string;
    ptp_reviews: string;
    advisor_ratings: string;
    advisor_reviews: string;
  };
  stars: number;
  title: string;
  url: string;
  city_url: string;
  pe_badge_title: string;
  badges: Array<{
    description: string;
    title: string;
    color: string;
    type: HotelBadgeType;
  }>;
  facilities: Array<{
    id: number;
    icon: string;
    title: string;
  }>;
  location: Array<number>;
  galleries: Array<{
    id: number;
    title: string;
    media: string;
    order_no: number;
  }>;
  snapp_pro_discount: boolean;
};

export type HotelDomesticSuggestedType = Pick<
  HotelDomesticType,
  | "instant_book"
  | "accommodation_title"
  | "accommodation_type"
  | "address"
  | "categories"
  | "city_id"
  | "city_title"
  | "cover_media"
  | "id"
  | "is_available"
  | "lang"
  | "price"
  | "price_off"
  | "min_price_room_title"
  | "min_price_available_room_count"
  | "reviews"
  | "stars"
  | "title"
  | "url"
  | "city_url"
  | "pe_badge_title"
  | "badges"
  | "facilities"
  | "galleries"
  | "rule_id"
  | "location"
  | "snapp_pro_discount"
> & {
  booking_type: string;
  maximum_discount_percent: number;
  minimum_room_foreign_price: number;
  minimum_room_price: number;
  minimum_room_price_off: number;
  maximum_loyalty_points: number;
  minimum_base_room_price: number;
  extra_data: {
    rack: {
      rooms: Array<number>;
      title: string;
      HotelId: number;
      description: string;
      is_allow_book: true;
    };
    guarantee: {
      is_guarantee: false;
    };
    hotel_badge_info: null;
  };
  provider: "extranet";
  need_confirm: true;
  is_non_extranet_available: false;
  show_priority: number;
  show_priority_old: number;
  room_info: [];
  contract_type: "";
};

export type HotelCityPriceRange = {
  min: number;
  max: number;
};

export type HotelCityFacilities = Array<{
  id: number | string;
  icon: string;
  title: string;
}>;

export type HotelCityAccommodations = Array<{ label: string; type: string }>;

export type HotelCityStars = Array<number>;

export type HotelCityRates = Array<number>;

export type CityPagePropertiesType = {
  seoData?: SeoDataResource;
  categoriesData?: HotelCategoriesType;
  locationData?: CityDataType;
  cityData?: CityDataType;
  hotelsData?: Array<
    HotelInfo & {
      page: number;
      total: number;
    }
  >;
  hotelSuggestionsData?: Array<HotelInfo>;
  hasError?: boolean;
  cityFilters?: {
    accommodations: HotelCityAccommodations;
    priceRange: HotelCityPriceRange;
    facilities: HotelCityFacilities;
    rates: HotelCityRates;
    stars: HotelCityStars;
  };
  smallBanners?: Array<MarketingBannerItemDataType>;
  staticBanners?: Array<MarketingBannerItemDataType>;
  inlineBanners?: Array<MarketingBannerItemDataType>;
  lastSecondHotels?: Array<HotelInfo>;
};

export type HotelDomesticSearchTextType = Array<{
  id: number;
  stars: number;
  fa_city_title: string;
  fa_state_title: string;
  fa_title: string;
  fa_url: string;
  hotel_count: number;
  provider: string;
  location: {
    lat: number;
    lon: number;
  };
}>;

export const reasonsSchema = {
  telesales_not_found: "عدم یافتن هتل مناسب",
  telesales_price_change: "تغییر قیمت",
  telesales_incident: "مشکلات فنی",
  telesales_complexities: "پیچیدگی رزرو آنلاین",
  telesales_help: "نیاز به راهنمایی کارشناس",
  telesales_do_not_trust: "عدم اعتماد به رزرو آنلاین",
  telesales_foreign_rate: "تفاوت نرخ رزرو برای اتباع خارجی",
  telesales_special_request: "درخواست‌های ویژه",
  telesales_child_rate: "استعلام نرخ کودک",
  telesales_lack_of_capacity: "عدم ظرفیت هتل مورد نظر"
};
